import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { Country } from '../../classess/country/country';
import { GlobalFormats, } from '../../classess/main/globalFormats';
import { CountryService } from '../../services/countries/CountryService';
import { getProcessButtons, handleResponseMessageAsync, isUndNullEmp, getResponse, settings, styles, getLanguageObj } from '../../helpers/main';

const currentMethod = 'CountryAddEditDetails';

const { icons, images, labels, messages, } = settings;

export default function CountryAddEditDetails({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtCountriesId: '',
        dtCountriesRowId: 0,
    },
    setModalObj = {},
    country = Country?.class({}, false),
    setCountry = {},
}) {
    //#region variables
    const [secondaryIdError, setSecondaryIdError] = useState('');
    const [nameError, setNameError] = useState('');
    const [dataFormLength] = useState(Country.minMaxLength(false));
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });
    const isMount = useRef(true);

    const controls = {
        buttons: {
            back: { id: 'btnBack' },
            save: { id: 'btnSave' },
            closeModal: { id: 'btnModalClose' },
        },
        icons: {
            save: { id: 'iconSave', defaultClass: icons?.fasFa?.save },
            back: { id: 'iconBack', defaultClass: icons?.fasFa?.arrowCircleLeft },
        },
        inputs: {
            secondaryId: { id: 'inputSecondaryId' },
            name: { id: 'inputName' },
        }
    };
    //#endregion variables

    //#region methods
    const addCountry = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'addCountry';
        try {
            if (e) e?.preventDefault?.();

            setErrorsDefault({
                subMethod: currentMethod,
            });

            response = validateFormData({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({
                ...prev,
                save: true,
            }));

            response = await CountryService.create({
                auth: modalObj?.auth,
                data: country,
                languageId: modalObj?.languageObj?.id || 'en',
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const newCountry = Country?.class(response?.result?.country, false);

            //#region update datatable
            modalObj.$(`#${modalObj.dtCountriesId}`).DataTable().row.add([
                newCountry.secundaryId,
                newCountry.name,
                getProcessButtons({
                    id: newCountry.id,
                    description: newCountry.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: true,
                })?.result,
            ])?.draw(false);
            //#endregion update datatable

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                save: false,
            }));

            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id || 'en',
                });
            }
        }
    }

    const editCountry = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'editCountry';
        try {
            if (e) e?.preventDefault?.();

            setErrorsDefault({
                subMethod: currentMethod,
            });

            response = validateFormData({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({
                ...prev,
                save: true,
            }));

            response = await CountryService.update({
                auth: modalObj?.auth,
                id: country.id,
                data: country,
                languageId: modalObj?.languageObj?.id || 'en',
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const updatedCountry = Country?.class(response?.result?.country, false);

            //#region update datatable row
            modalObj.$(`#${modalObj.dtCountriesId}`).DataTable().row(modalObj.dtCountriesRowId).data([
                updatedCountry.secundaryId,
                updatedCountry.name,
                getProcessButtons({
                    id: updatedCountry.id,
                    description: updatedCountry.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: true,
                })?.result,
            ])?.draw(false);
            //#endregion update datatable row

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                save: false,
            }));

            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id || 'en',
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.log(response.msgText);
        }
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            let hasError = false;
            const requiredMsg = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;

            if (isUndNullEmp({ data: country?.secundaryId, subMethod: currentMethod })?.result) {
                setSecondaryIdError(requiredMsg);
                hasError = true;
            }

            if (isUndNullEmp({ data: country?.name, subMethod: currentMethod })?.result) {
                setNameError(requiredMsg);
                hasError = true;
            }

            if (hasError) response.isWarning = true;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        setSecondaryIdError('');
        setNameError('');
        return getResponse({ type: 0 });
    }

    useEffect(() => {
        isMount.current = true;
        return () => {
            isMount.current = false;
        }
    }, []);
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <form onSubmit={(e) => modalObj?.type === 0 ? addCountry({ e: e }) : editCountry({ e: e })}>
                {/* Modal Header */}
                <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                    <Modal.Title className='d-flex align-items-center w-100'>
                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img alt='country' src={images?.icons?.country} style={{ width: '25px', height: '25px', objectFit: 'contain' }}></img>
                        </div>
                        <div className='d-flex flex-column'>
                            <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.country?.[modalObj?.languageObj?.id]}</span>
                            <div className='d-flex align-items-center mt-1'>
                                <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`}
                                    style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>
                                    {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                        modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                            labels?.detail?.[modalObj?.languageObj?.id]}
                                </span>
                            </div>
                        </div>
                    </Modal.Title>
                    <button id={controls?.buttons?.closeModal?.id}
                        type='button'
                        className='close border-0 bg-transparent'
                        disabled={process?.save}
                        style={{ fontSize: '1.5rem', marginTop: '-15px', color: '#6c757d', opacity: '0.5' }}
                        onClick={() => setDefaultValue({ closeModal: true })}>
                        <span aria-hidden='true'>&times;</span>
                    </button>
                </Modal.Header>
                {/* /.Modal Header */}

                {/* Modal Body */}
                <Modal.Body className='p-0'>

                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ? (
                            <div className='row'>
                                <div className='col-md-12 mb-4'>
                                    <div className='form-group mb-0'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.indentFasFa} /> {labels?.code?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input autoFocus
                                            disabled={process?.save}
                                            id={controls?.inputs?.secondaryId.id}
                                            className='form-control bg-light border-0 shadow-sm text-dark'
                                            style={{ borderRadius: '5px' }}
                                            maxLength={dataFormLength?.max?.secundaryId}
                                            onChange={(e) => setCountry(prev => ({ ...prev, secundaryId: e?.target?.value }))}
                                            onFocus={() => setSecondaryIdError('')}
                                            value={country?.secundaryId || ''}
                                            placeholder={labels?.code?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text ml-3 mt-1' style={styles?.inputMsgAlert}>{parse(secondaryIdError)}</div>
                                    </div>
                                </div>

                                <div className='col-md-12 mb-2'>
                                    <div className='form-group mb-0'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input
                                            disabled={process?.save}
                                            id={controls?.inputs?.name?.id}
                                            className='form-control bg-light border-0 shadow-sm text-dark'
                                            style={{ borderRadius: '5px' }}
                                            maxLength={dataFormLength?.max?.name}
                                            onChange={(e) => setCountry(prev => ({ ...prev, name: e?.target?.value }))}
                                            onFocus={() => setNameError('')}
                                            value={country?.name || ''}
                                            placeholder={labels?.name?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text ml-3 mt-1' style={styles?.inputMsgAlert}>{parse(nameError)}</div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm' style={{ overflowWrap: 'break-word', borderLeftWidth: '4px' }}>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h5 mb-0 font-weight-bold text-dark'>{country?.name || '---'}</div>
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm' style={{ overflowWrap: 'break-word', borderLeftWidth: '4px' }}>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.indentFasFa} /> {labels?.code?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold text-secondary'>{country?.secundaryId || '---'}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </Modal.Body>
                {/* /.Modal Body */}

                {/* Modal Footer */}
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button id={controls?.buttons?.save?.id}
                            className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4'
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.save?.id} className={`${controls?.icons?.save?.defaultClass}`} />
                            )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className='btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4'
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            title={labels?.close?.[modalObj?.languageObj?.id]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true })}>
                            <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass}`}></i> {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
                {/* /.Modal Footer */}
            </form>
        </Modal>
    )
}